// Deterministic color generator for covers based on string input
export const getCoverGradient = (str: string): string => {
  const hash = str.split('').reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const gradients = [
    'from-emerald-700 to-teal-900',
    'from-slate-700 to-slate-900',
    'from-orange-700 to-red-900',
    'from-indigo-700 to-purple-900',
    'from-pink-700 to-rose-900',
    'from-blue-700 to-cyan-900',
    'from-amber-700 to-yellow-900',
    'from-fuchsia-700 to-purple-900',
  ];
  return gradients[Math.abs(hash) % gradients.length];
};
